import { useState, useRef } from "react";
import { windowStyle } from "./style.js";
import { MinusOutlined, PlusOutlined, CloseOutlined } from "@ant-design/icons";
import { themeColors } from "../../config.js";
import Draggable from "../Draggable";
import Resizeable from "../Resizeable";
import { lString } from "../../utils.js";

const Window = ({
  id,
  top,
  left,
  name,
  children,
  width = 400,
  height = 400,
  minWidth = 200,
  minHeight = 200,
  onClick = () => {},
  onCancel = () => {},
  onResize = () => {},
  onFinishResize = () => {},
  onFinishDrag = () => {},
}) => {
  const [screenMode, changeScreenMode] = useState(1);
  const [posY, changeY] = useState(top);
  const [posX, changeX] = useState(left);

  const headerRef = useRef();

  const highlight = (e) => {
    e.target.style.opacity = 0.5;
  };
  const unhighlight = (e) => {
    e.target.style.opacity = 1;
  };
  const changeMode = (diff) => {
    changeScreenMode(Math.max(0, Math.min(2, screenMode + diff)));
  };
  const changePosition = (x, y) => {
    changeX(x);
    changeY(y);
  };

  const panel = (
    <div style={windowStyle.panel}>
      <div style={windowStyle.title} ref={headerRef}>
        {screenMode === 0
          ? lString(name, 8, "...")
          : screenMode === 1
          ? lString(name, 25, "...")
          : lString(name, 50, "...")}
      </div>
      {screenMode === 0 ? (
        <></>
      ) : (
        <div
          style={{
            ...windowStyle.controlBtn,
            backgroundColor: themeColors.green,
          }}
          onClick={() => changeMode(-1)}
          onMouseOver={highlight}
          onMouseOut={unhighlight}
        >
          <MinusOutlined
            style={{ fontSize: 10, color: themeColors.transparentBlack }}
          />
        </div>
      )}
      {screenMode === 2 ? (
        <></>
      ) : (
        <div
          style={{
            ...windowStyle.controlBtn,
            backgroundColor: themeColors.yellow,
          }}
          onClick={() => changeMode(1)}
          onMouseOver={highlight}
          onMouseOut={unhighlight}
        >
          <PlusOutlined
            style={{ fontSize: 10, color: themeColors.transparentBlack }}
          />
        </div>
      )}
      <div
        style={{
          ...windowStyle.controlBtn,
          backgroundColor: themeColors.red,
        }}
        onClick={onCancel}
        onMouseOver={highlight}
        onMouseOut={unhighlight}
      >
        <CloseOutlined
          style={{ fontSize: 10, color: themeColors.transparentBlack }}
        />
      </div>
    </div>
  );

  return (
    <Draggable
      id={id}
      draggable={screenMode === 1 || screenMode === 0}
      headerRef={headerRef}
      changePosition={changePosition}
      onClick={onClick}
      onFinishDrag={onFinishDrag}
      style={
        screenMode === 2
          ? {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: themeColors.windowBackground,
              zIndex: 11,
              transition: "top 0.1s, left 0.1s",
            }
          : {
              position: "fixed",
              top: posY,
              left: posX,
              backgroundColor: themeColors.windowBackground,
              zIndex: 11,
              transition: "top 0.1s, left 0.1s",
            }
      }
    >
      <Resizeable
        resizeable={screenMode !== 0}
        screenMode={screenMode}
        onResize={onResize}
        onFinishResize={onFinishResize}
        initWidth={width}
        initHeight={height}
        minWidth={minWidth}
        minHeight={minHeight}
        style={{
          border: screenMode === 1 ? "1px solid white" : "none",
          borderRadius: screenMode === 1 ? 5 : 0,
        }}
      >
        {panel}
        <div
          style={{
            ...windowStyle.content,
            display: screenMode === 0 ? "none" : "flex",
          }}
        >
          {children}
        </div>
      </Resizeable>
    </Draggable>
  );
};

export default Window;
